var _a;
import { __decorate, __metadata } from "tslib";
import { IScope } from 'angular';
import { Component } from 'decorators';
import './builderAutocomplete.scss';
import BuilderAutocompleteView from './BuilderAutocompleteView.html';
import { v4 as uuidV4 } from 'uuid';
export const BUILDER_AUTOCOMPLETE_ADDED_A_NEW_OPTION = 'builder-autocomplete-new-option-added';
export const BUILDER_AUTOCOMPLETE_SELECTED_AN_OPTION = 'builder-autocomplete-selected-option';
const BUILDER_AUTOCOMPLETE_SAME_WORDS_SEARCH = 'same_words';
let BuilderAutocompleteComponent = class BuilderAutocompleteComponent {
    static $inject = ['$scope'];
    constructor($scope) {
        'ngInject';
        this.hasValidation = false;
        this.$onInit = () => {
            const id = uuidV4();
            this.autocompleteId = this.autocompleteId ? this.autocompleteId : `builder-autocomplete-${id}`;
            if (this.error === undefined) {
                this.error = false;
            }
            else {
                this.hasValidation = true;
                this.error = this.error ? this.error : false;
            }
            this.modalId = `builder-autocomplete-modal-${id}`;
        };
        this.$onChanges = (changes) => {
            if (changes.options) {
                this.updateSelectedOptionByLabelValue();
            }
            if (changes.isDisabled && !changes.isDisabled.isFirstChange()) {
                this.isDisabled = changes.isDisabled.currentValue;
            }
            if (changes.error) {
                this.error = changes.error.currentValue;
            }
        };
        this.onKeyDown = ({ key }) => {
            switch (key) {
                case 'Enter':
                    if (document.getElementById(this.modalId).style.display === 'block') {
                        this.$onAddNewOption();
                    }
            }
        };
        this.inputChanged = (e) => {
            const value = e.target.shadowRoot.querySelector('input').value;
            this.labelToAdd = this.createSurveyOption || value;
            this._scope.$apply();
            this.verifyToShowModalCreation();
        };
        this.onBlur = (e) => {
            setTimeout(() => {
                this.hideOrShowModal(false);
                if (this.hasValidation && !this.isDisabled) {
                    this.error = !e.target.value;
                }
            }, 250);
        };
        this.$onSelectOption = (event) => {
            const value = event?.detail?.value;
            if (!value) {
                return;
            }
            this.value = value;
            this.onSelectOption({ value });
        };
        this.$onAddNewOption = () => {
            if (this.labelToAdd) {
                this.value = this.labelToAdd;
                document.getElementById(this.autocompleteId).shadowRoot.querySelector('input').value = this.labelToAdd;
                this.onAddNewOption({ newValue: this.labelToAdd });
            }
            this.hideOrShowModal(false);
        };
        this.updateSelectedOptionByLabelValue = () => {
            const option = this.options?.find(option => option.value === this.value || option.label === this.value);
            if (option?.value) {
                this.value = option.value;
            }
        };
        this._scope = $scope;
    }
    verifyToShowModalCreation() {
        let showModal = false;
        if (this.createSurveyOption != undefined) {
            showModal = this.options.length == 0;
        }
        else {
            switch (this.typeOfSearch) {
                case BUILDER_AUTOCOMPLETE_SAME_WORDS_SEARCH:
                    showModal = !this.options.find(option => option.label === this.labelToAdd) && !!this.labelToAdd.trim();
                    break;
                default:
                    showModal = !this.options.find(option => option.label.toLowerCase().includes(this.labelToAdd.toLowerCase())) && !!this.labelToAdd.trim();
                    break;
            }
        }
        setTimeout(() => {
            this.hideOrShowModal(showModal);
        }, 100);
    }
    hideOrShowModal(showModal) {
        const modal = document.getElementById(this.modalId);
        const modalMessage = modal.querySelector('.builder-autocomplete-modal-message');
        const openedOptions = document
            .getElementById(this.autocompleteId)
            .shadowRoot
            .querySelector('.select__options--open');
        let modalHeight = '0px';
        if (openedOptions) {
            //Workaround to prevent dropdown from not opening
            openedOptions.classList.remove('select__options--position-top');
            const optionsStyle = window.getComputedStyle(openedOptions);
            if (optionsStyle.visibility === 'visible') {
                modalHeight = optionsStyle.height;
            }
        }
        else {
            showModal = false;
        }
        switch (showModal) {
            case true:
                modal.style.top = modalHeight;
                modalMessage.style.display = modalHeight === '0px' ? 'block' : 'none';
                modal.style.display = 'block';
                break;
            default:
                if (modal.style.display !== 'none') {
                    modal.style.display = 'none';
                }
                break;
        }
    }
};
BuilderAutocompleteComponent.$inject = ['$scope'];
BuilderAutocompleteComponent = __decorate([
    Component({
        controllerAs: '$ctrl',
        template: BuilderAutocompleteView,
        bindings: {
            autocompleteId: '@',
            error: '<',
            buttonMessage: '@',
            label: '@',
            options: '<',
            value: '<',
            typeOfSearch: '@',
            onAddNewOption: '&',
            onSelectOption: '&',
            createSurveyOption: '<',
            isDisabled: '<',
        },
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof IScope !== "undefined" && IScope) === "function" ? _a : Object])
], BuilderAutocompleteComponent);
export { BuilderAutocompleteComponent };
